import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#1F2937" },
    secondary: { main: "#2563EB" },
    background: { default: "#F9FAFB" },
  },
  shape: {
    borderRadius: 8,
  },
});

export default theme;
